'use client';

import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'next/navigation';
import { urlParameterCodes } from '@/constants/urlParams';
import { NU_FLOWS } from './nu-flows';

// Shows a registered NU_FLOWS entry over the current page, e.g.
// /en-de/some-page?nuFlow=kp2_nfc_tamper_exchange opens Kp2NfcTamperExchangeOverlay there;
// closing it removes nuFlow from the URL and the visitor stays on /en-de/some-page.
export function NuFlowHost() {
  const searchParams = useSearchParams();
  const requestedNuFlowId = searchParams.get(urlParameterCodes.nuFlow);
  // Stays set after closing, so the flow can animate out instead of vanishing
  const [shownNuFlowId, setShownNuFlowId] = useState<string | null>(null);

  useEffect(() => {
    if (requestedNuFlowId && NU_FLOWS[requestedNuFlowId]) {
      setShownNuFlowId(requestedNuFlowId);
    }
  }, [requestedNuFlowId]);

  const NuFlow = shownNuFlowId ? NU_FLOWS[shownNuFlowId] : undefined;

  if (!NuFlow) {
    return null;
  }

  const closeNuFlow = () => {
    const url = new URL(globalThis.location.href);
    url.searchParams.delete(urlParameterCodes.nuFlow);
    // Next.js syncs replaceState with useSearchParams without reloading the page
    globalThis.history.replaceState(null, '', url);
  };

  return <NuFlow open={requestedNuFlowId === shownNuFlowId} onClose={closeNuFlow} />;
}
